// Carry Roll UI store — ephemeral modal/drawer open/close state.
// Separate from the persisted app store so transient UI state is never saved.

import { create } from 'zustand';
import type { UserFeedback } from '../utils/userFeedback';

export interface FeedbackConfig {
  type?: UserFeedback['type'] | undefined;
  category?: string | undefined;
  error?: string | undefined;
}

interface UIState {
  aboutOpen: boolean;
  openAbout: () => void;
  closeAbout: () => void;
  settingsDrawerOpen: boolean;
  openSettingsDrawer: () => void;
  closeSettingsDrawer: () => void;
  feedbackOpen: boolean;
  feedbackConfig: FeedbackConfig;
  openFeedback: (type?: UserFeedback['type'], category?: string, error?: string) => void;
  closeFeedback: () => void;
  demoPickerOpen: boolean;
  openDemoPicker: () => void;
  closeDemoPicker: () => void;
}

export const useUI = create<UIState>((set) => ({
  aboutOpen: false,
  openAbout: () => set({ aboutOpen: true }),
  closeAbout: () => set({ aboutOpen: false }),
  settingsDrawerOpen: false,
  openSettingsDrawer: () => set({ settingsDrawerOpen: true }),
  closeSettingsDrawer: () => set({ settingsDrawerOpen: false }),
  feedbackOpen: false,
  feedbackConfig: {},
  openFeedback: (type, category, error) =>
    set({ feedbackConfig: { type, category, error }, feedbackOpen: true }),
  closeFeedback: () => set({ feedbackOpen: false, feedbackConfig: {} }),
  demoPickerOpen: false,
  openDemoPicker: () => set({ demoPickerOpen: true }),
  closeDemoPicker: () => set({ demoPickerOpen: false }),
}));
